import { UnreachableCaseError } from "./errors";
import { CSSProperties } from "react";
import { cssColorToRgb, RgbColor } from "client/Misc/colorFunctions";
import {
	SaveAppColorModel,
	CustomSaveAppColorModel,
	AppColorKind,
	AppColorViewModel
} from "client/Api/Apps/common";

export function isCustomSaveAppColor(color: SaveAppColorModel): color is CustomSaveAppColorModel {
	return color.kind === AppColorKind.Custom;
}

const RED: RgbColor = { r: 255, g: 0, b: 0 };

function getWayOfColoring(color: AppColorViewModel): WayOfColoring {
	switch (color.kind) {
		case AppColorKind.Inherit:
			return { kind: "none" };
		case AppColorKind.Header:
			return { kind: "class", name: "app-color--header" };
		case AppColorKind.Primary:
			return { kind: "class", name: "app-color--primary" };
		case AppColorKind.Custom:
			let rgb: RgbColor | undefined;
			try {
				rgb = cssColorToRgb(color.value);
			} catch (e) {
				console.error(`Failed to convert '${color.value}' to rgb`, e);
			}

			if (!rgb) {
				rgb = RED;
			}

			const {r, g, b} = rgb;
			return {
				kind: "inline-style",
				properties: [
					{ name: "--app-color-r", value: r.toString() },
					{ name: "--app-color-g", value: g.toString() },
					{ name: "--app-color-b", value: b.toString() },
				]
			};
		default:
			throw new UnreachableCaseError(color);
	}
}

type WayOfColoring = { kind: "none"; }
	| { kind: "inline-style"; properties: { name: keyof CSSProperties; value: string; }[]; }
	| { kind: "class"; name: string; };


type ReactColorAttributes = {
	colorStyle?: CSSProperties;
	colorClass: string;
};

export function getReactColorAttributes(
	color: AppColorViewModel | undefined | null
): ReactColorAttributes {
	const result: ReactColorAttributes = {
		colorClass: "app-color"
	};

	if (color)
	{
		const wayOfColoring: WayOfColoring = getWayOfColoring(
			color
		);

		switch (wayOfColoring.kind) {
			case "none":
				// Nothing additional
				break;
			case "class":
				result.colorClass += ` ${wayOfColoring.name}`;
				break;
			case "inline-style":
				const style: CSSProperties = {};
				for (const prop of wayOfColoring.properties) {
					// @ts-expect-error Expression produces a union type that is too complex to represent.ts(2590)
					style[prop.name] = prop.value;
				}
				result.colorStyle = style;
				break;
			default:
				throw new UnreachableCaseError(wayOfColoring);
		}
	}

	return result;
}
